module.exports = __webpack_public_path__ + "static/media/calMselected.7e1264a4.svg";